import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ChangePasswordCard from './components/ChangePasswordCard';

const PromotionSend = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Change Password</h3>
      </Col>
    </Row>
    <Row>
      <ChangePasswordCard />
    </Row>
  </Container>
);

export default PromotionSend;
